import { CartItem } from "@/types";

export function formatProducts(items: CartItem[]) {

    const products: {
        name: string,
        price: number,
        variant: string,
        quantity: number
    }[] = [];

    
    items.forEach(function (item) {
        (item.participantList ?? item.unitList ?? []).forEach(participant => {
            products.push({
                name: item.name,
                price: participant.price,
                variant: participant.tier.label,
                quantity: 1
            })
        })
    });



    return products;
}